import { matchSorter } from 'match-sorter';
import { DateTime } from 'luxon';
import omitBy from 'lodash/omitBy';
import get from 'lodash/get';

export const applyFilters = (data = [], filters = {}) => {
    const matchers = buildMatchers(filters);

    return Object.keys(matchers)
        .reduce(
            (result, filterName) => matchers[filterName](result),
            data || []
        );
};

const opts = (keys) => ({ keys, sorter: d => d });

const ownerKeys = [
    data => data.owners.map(o => get(o, 'firstName', null)),
    data => data.owners.map(o => get(o, 'middleName', null)),
    data => data.owners.map(o => get(o, 'lastName', null)),
    data => data.owners.map(o => get(o, 'primary.firstName', null)),
    data => data.owners.map(o => get(o, 'primary.middleName', null)),
    data => data.owners.map(o => get(o, 'primary.lastName', null)),
    data => data.owners.map(o => get(o, 'secondary.firstName', null)),
    data => data.owners.map(o => get(o, 'secondary.middleName', null)),
    data => data.owners.map(o => get(o, 'secondary.lastName', null)),
    data => data.owners.map(o => get(o, 'entityName', null))
];

function buildMatchers (filters = { }) {
    let matchers = {
        filenumber: data => matchSorter(data, filters.filenumber, opts(['filenumber'])),
        ownerName: data => matchMultiple(data, filters.ownerName, ownerKeys),
        address: data => matchMultiple(data, filters.address, ['streetAddress']),
        status: data => matchMultiSelect(data, filters.status, ['status']),
        nextStep: data => matchMultiSelect(data, filters.nextStep, ['nextStep']),
        submissionStart: data => backDate(data, DateTime.fromJSDate(filters.submissionStart), ['submitted']),
        submissionEnd: data => forwardDate(data, DateTime.fromJSDate(filters.submissionEnd), ['submitted'])
    };

    return omitBy(matchers, (_, key) => !filters[key]);
}

function matchMultiple(data, value, keys) {
    if (!value || !value.length)
        return data;

    const terms = value.split(' ');

    if (!terms)
        return data;
    
    return terms.reduceRight(
        (results, term) => matchSorter(results, term, opts(keys)),
        data
    );
}

function matchSelect(data, option, keys) {
    if (!option || !option.value)
        return data;

    const { value } = option;

    return matchSorter(data, value, opts(keys));
}

function matchMultiSelect(data, options, keys) {
    if (options?.length === 0) return data;
    return options.reduce(
        (result, option) => [ ...result, ...matchSelect(data, option, keys) ],
        []
    );
}

function backDate(data, since, keys = [], includeInvalid = true) {
    if (!since || !since.isValid)
        return data;

    const _keys = keys.map(k => {
        return (item) => {
            const dateToCheck = DateTime.fromISO(item[k]);
            if (dateToCheck.isValid) {
                return dateToCheck > since;
            } else {
                return includeInvalid;
            }
        };
    });
    
    return matchSorter(data, 'true', opts(_keys));
}

function forwardDate(data, date, keys = [], includeInvalid = true) {
    if (!date || !date.isValid)
        return data;

    const _keys = keys.map(k => {
        return (item) => {
            const dateToCheck = DateTime.fromISO(item[k]);
            if (dateToCheck.isValid) {
                return dateToCheck < date;
            } else {
                return includeInvalid;
            }
        };
    });
    
    return matchSorter(data, 'true', opts(_keys));
}